<div class="header">
  <div class="wrapper header__inner">
    <div class="header__logo">
      <img src="/assets/images/logo_white.png" alt="Логотип" *ngIf="this.currentUrl() === '/login'"/>
      <img src="/assets/images/logo.png" alt="Логотип" *ngIf="this.currentUrl() !== '/login'"/>
    </div>

    <div class="header__right">
      <div class="header__support">
        <a
          class="header__phone"
          [ngClass]="this.currentUrl() === '/login' ? 'header__phone light' : 'header__phone'"
          [href]="'tel:' + supportPhone"
          *ngIf="supportPhone"
        >
          {{ supportPhone }}
        </a>
      </div>

<div class="action-wrapper">
      <button
        *ngIf="showExitButton"
        type="button"
        class="header__logout"
        (click)="onFeedbackButtonClick()"
      >
        <img src="./assets/images/help.svg" alt="help"/>
        <span>Обратная связь</span>
      </button>
      <button
        *ngIf="showExitButton"
        type="button"
        class="header__logout"
        (click)="logout()"
      >
        <i class="pi pi-sign-out"></i>
        <span>Выйти</span>
      </button>
</div>
    </div>
  </div>
</div>
